import React, { useEffect } from 'react';
import { Form, Input, Card, Row, Col, Space, theme } from 'antd';
import { FireOutlined, ReloadOutlined, StarOutlined, MessageOutlined } from '@ant-design/icons';

const BasicInfoStep = ({ campaignProcessed, selectedCampaignType, onCampaignTypeChange, prefetchData }) => {
  const { token } = theme.useToken();
  const { setFieldValue } = Form.useFormInstance() || {}; // Acessa a instância do formulário pai
  
  // Estilo comum para todos os cards para garantir o mesmo tamanho
  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  };
  
  // Estilo para o container do conteúdo dentro do card
  const cardContentStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  };

  const handleCardClick = (type) => {
    if (campaignProcessed) return;
    
    // Atualiza o state local para controle visual
    onCampaignTypeChange(type);
    
    // Atualiza o valor no formulário pai se disponível
    if (setFieldValue) {
      setFieldValue('kind', type);
    }
    
    // If switching to offer type, prefetch product and customer data
    if (type === 'offer') {
      prefetchData();
    }
  };
  
  // Sincroniza o form quando o componente é montado ou quando selectedCampaignType muda
  useEffect(() => {
    if (setFieldValue) {
      setFieldValue('kind', selectedCampaignType);
    }
  }, [setFieldValue, selectedCampaignType]);
  
  return (
    <Card>
      <Form.Item
        name="name"
        label="Nome da Campanha"
        rules={[{ required: true, message: 'Por favor, digite o nome da campanha' }]}
      >
        <Input placeholder="Digite o nome da campanha" disabled={campaignProcessed} />
      </Form.Item>
      
      <Form.Item
        label="Tipo de Campanha"
      >
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Card 
              hoverable 
              style={{ 
                ...cardStyle,
                borderColor: selectedCampaignType === 'offer' ? token.colorPrimary : undefined,
                backgroundColor: selectedCampaignType === 'offer' ? `${token.colorPrimary}10` : undefined
              }}
              bodyStyle={{ height: '100%', padding: '16px' }}
              onClick={() => handleCardClick('offer')}
            >
              <div style={cardContentStyle}>
                <div>
                  <Space>
                    <FireOutlined style={{ color: selectedCampaignType === 'offer' ? token.colorPrimary : '#ff4d4f' }} />
                    <span><strong>Oferta</strong></span>
                  </Space>
                </div>
                <div style={{ marginTop: 8 }}>
                  Promova produtos específicos
                </div>
              </div>
            </Card>
          </Col>
          <Col span={6}>
            <Card 
              hoverable 
              style={{ 
                ...cardStyle,
                borderColor: selectedCampaignType === 'reactivation' ? token.colorPrimary : undefined,
                backgroundColor: selectedCampaignType === 'reactivation' ? `${token.colorPrimary}10` : undefined
              }}
              bodyStyle={{ height: '100%', padding: '16px' }}
              onClick={() => handleCardClick('reactivation')}
            >
              <div style={cardContentStyle}>
                <div>
                  <Space>
                    <ReloadOutlined style={{ color: selectedCampaignType === 'reactivation' ? token.colorPrimary : '#1890ff' }} />
                    <span><strong>Reativação</strong></span>
                  </Space>
                </div>
                <div style={{ marginTop: 8 }}>
                  Reconquistar clientes inativos
                </div>
              </div>
            </Card>
          </Col>
          <Col span={6}>
            <Card 
              hoverable 
              style={{ 
                ...cardStyle,
                borderColor: selectedCampaignType === 'activation' ? token.colorPrimary : undefined,
                backgroundColor: selectedCampaignType === 'activation' ? `${token.colorPrimary}10` : undefined
              }}
              bodyStyle={{ height: '100%', padding: '16px' }}
              onClick={() => handleCardClick('activation')}
            >
              <div style={cardContentStyle}>
                <div>
                  <Space>
                    <StarOutlined style={{ color: selectedCampaignType === 'activation' ? token.colorPrimary : '#52c41a' }} />
                    <span><strong>Ativação</strong></span>
                  </Space>
                </div>
                <div style={{ marginTop: 8 }}>
                  Boas-vindas a novos clientes
                </div>
              </div>
            </Card>
          </Col>
          <Col span={6}>
            <Card 
              hoverable 
              style={{ 
                ...cardStyle,
                borderColor: selectedCampaignType === 'follow_up' ? token.colorPrimary : undefined,
                backgroundColor: selectedCampaignType === 'follow_up' ? `${token.colorPrimary}10` : undefined
              }}
              bodyStyle={{ height: '100%', padding: '16px' }}
              onClick={() => handleCardClick('follow_up')}
            >
              <div style={cardContentStyle}>
                <div>
                  <Space>
                    <MessageOutlined style={{ color: selectedCampaignType === 'follow_up' ? token.colorPrimary : '#faad14' }} />
                    <span><strong>Follow Up</strong></span>
                  </Space>
                </div>
                <div style={{ marginTop: 8 }}>
                  Acompanhamento personalizado
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Form.Item>
      
      {/* Campo oculto para armazenar o valor no formulário */}
      <Form.Item
        name="kind"
        rules={[{ required: true, message: 'Por favor, selecione o tipo de campanha' }]}
        hidden
      >
        <Input type="hidden" />
      </Form.Item>
    </Card>
  );
};

export default BasicInfoStep; 